var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcBurgerMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51504F",
    fillRule: "evenodd",
    d: "M7.238 11h29.523c.957 0 1.74.783 1.74 1.74v.187c0 .957-.783 1.74-1.74 1.74H7.238c-.957 0-1.738-.783-1.738-1.74v-.187c0-.957.781-1.74 1.738-1.74zm29.523 9.167H7.238c-.957 0-1.738.782-1.738 1.74v.186c0 .957.781 1.74 1.738 1.74h29.523c.957 0 1.74-.782 1.74-1.74v-.186c0-.957-.783-1.74-1.74-1.74zm0 9.166H7.238c-.957 0-1.738.783-1.738 1.74v.187c0 .957.781 1.74 1.738 1.74h29.523c.957 0 1.74-.783 1.74-1.74v-.187c0-.957-.783-1.74-1.74-1.74z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBurgerMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_burger_menu.aab180d8.svg";
export { ForwardRef as ReactComponent };